// extracted by mini-css-extract-plugin
module.exports = {"accumulatorIcon":"_0c072ee","accumulatorIconBadge":"_25faac6"};